export { createNoeVaultSnap } from './createNoeVaultSnap';
export type {
  NoeVaultSnapInstance,
  SnapCreateOptions,
  SnapBrowserBootstrap,
  SnapSubmitInput,
  SnapSubmitResult,
  SnapError,
  SnapEventName,
  SnapEventMap,
  SnapThemeOptions,
  SnapApplicationContext,
  SnapFailureKind,
  SnapExperienceConfiguration,
  SnapClaimOffer,
  SnapClaimInviteRequest,
  SnapClaimInviteResult,
  SnapClaimCompleteRequest,
  SnapClaimCompleteResult
} from './types';
export {
  SNAP_CONTRACT_VERSION,
  SNAP_PACKAGE_ID,
  SNAP_PACKAGE_VERSION,
  SNAP_BUILD_MARKER,
  SnapDenyCodes
} from './types';
export { validateBootstrap, normalizeBootstrap, defaultPolicies } from './bootstrap/validate';
export { sanitizeApplicationContext, collectBrowserContext } from './context/contextModel';
export { preflightAttachments } from './attachments/preflight';
export { AttachmentPicker } from './attachments/attachmentPicker';
export { AnnotationSession } from './annotation/annotationSession';
export type { AnnotationTool, AnnotationEdit } from './annotation/annotationSession';
export { SnapScreenEditor } from './editor/snapScreenEditor';
export type { SnapScreenEditorOptions, SnapScreenEditorVariant } from './editor/snapScreenEditor';
export {
  validateRequestComposer
} from './composer/requestComposer';
export type {
  RequestComposerValues,
  RequestComposerValidation
} from './composer/requestComposer';
export {
  listMyRequests,
  getRequestDetail,
  addRequestComment,
  createConversationPoller
} from './requests/myRequests';
export { REDACTION_LIMITATIONS } from './redaction/neverCapture';
export { isExcludedElement, hideExcludedElements } from './redaction/neverCapture';
export { assertNoEvalInSource, escapeHtml, createSnapError } from './security/sanitize';
export { CustomerMessages, mapCustomerError } from './security/customerErrors';
export { requestAccountClaim } from './claim/accountClaim';

import { createNoeVaultSnap } from './createNoeVaultSnap';
import type { NoeVaultSnapInstance, SnapCreateOptions } from './types';

/** Controlled-pilot public alias: create + initialize. */
export async function init(options: SnapCreateOptions = {}): Promise<NoeVaultSnapInstance> {
  const snap = createNoeVaultSnap(options);
  await snap.initialize(options.bootstrap);
  return snap;
}
